import { GlBadge, GlButton, GlLoadingIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import HelpIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/help_icon/help_icon.vue?vue3';
import { isLoggedIn } from '~/lib/utils/common_utils';
import { __ } from '~/locale';
import ApplySuggestion from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/markdown/apply_suggestion.vue?vue3';
const APPLY_SUGGESTION_ERROR_MESSAGE = __('Unable to fully load the default commit message. You can still apply this suggestion and the commit message will be correct.');
export default {
    name: 'SuggestionDiffHeader',
    components: {
        GlBadge,
        GlButton,
        GlLoadingIcon,
        ApplySuggestion,
        HelpIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        batchSuggestionsCount: {
            type: Number,
            required: false,
            default: 0
        },
        canApply: {
            type: Boolean,
            required: false,
            default: false
        },
        isApplied: {
            type: Boolean,
            required: true
        },
        isBatched: {
            type: Boolean,
            required: false,
            default: false
        },
        isApplyingBatch: {
            type: Boolean,
            required: false,
            default: false
        },
        helpPagePath: {
            type: String,
            required: true
        },
        defaultCommitMessage: {
            type: String,
            required: false,
            default: null
        },
        inapplicableReason: {
            type: String,
            required: false,
            default: null
        },
        suggestionsCount: {
            type: Number,
            required: false,
            default: 0
        },
        failedToLoadMetadata: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'add-to-batch',
        'apply',
        'apply-batch',
        'remove-from-batch'
    ],
    data () {
        return {
            isApplyingSingle: false
        };
    },
    computed: {
        isApplying () {
            return this.isApplyingSingle || this.isApplyingBatch;
        },
        tooltipMessage () {
            if (!this.canApply) {
                return this.inapplicableReason;
            }
            return false;
        },
        isDisableButton () {
            return this.isApplying || !this.canApply;
        },
        applyingSuggestionsMessage () {
            if (this.isApplyingSingle || this.batchSuggestionsCount < 2) {
                return __('Applying suggestion…');
            }
            return __('Applying suggestions…');
        },
        isLoggedIn () {
            return isLoggedIn();
        },
        showApplySuggestion () {
            if (!this.isLoggedIn) return false;
            if (this.batchSuggestionsCount >= 1 && !this.isBatched) {
                return false;
            }
            return true;
        },
        applySuggestionErrorMessage () {
            return this.failedToLoadMetadata ? APPLY_SUGGESTION_ERROR_MESSAGE : null;
        }
    },
    methods: {
        apply (message) {
            if (this.batchSuggestionsCount > 1) {
                this.applySuggestionBatch(message);
            } else {
                this.applySuggestion(message);
            }
        },
        applySuggestion (message) {
            if (!this.canApply) return;
            this.isApplyingSingle = true;
            this.$emit('apply', this.applySuggestionCallback, message);
        },
        applySuggestionCallback () {
            this.isApplyingSingle = false;
        },
        applySuggestionBatch (message) {
            if (!this.canApply) return;
            this.$emit('apply-batch', message);
        },
        addSuggestionToBatch () {
            this.$emit('add-to-batch');
        },
        removeSuggestionFromBatch () {
            this.$emit('remove-from-batch');
        }
    }
};
